module.exports = __webpack_public_path__ + "assets/img/stzt_icon.6a20b4c9.png";